export interface ListPaginationState {
  pagination: boolean;
  pageNo: number;
  rowCount: number;
  totalRows: number;
  lastFetchedCount: number;
}

export interface ListPaginationConfig {
  rowCount?: number;
  pagination?: boolean;
}

export function createListPaginationState(config: ListPaginationConfig = {}): ListPaginationState {
  return {
    pagination: config.pagination ?? true,
    pageNo: 0,
    rowCount: config.rowCount ?? 10,
    totalRows: 0,
    lastFetchedCount: 0
  };
}

export function resetListPaginationState(state: ListPaginationState): void {
  state.pageNo = 0;
  state.totalRows = 0;
  state.lastFetchedCount = 0;
}

export function hasMoreByTotal<T>(items: T[], state: ListPaginationState): boolean {
  if (items.length < state.totalRows) {
    return true;
  }

  return state.lastFetchedCount >= state.rowCount;
}

export function resolveRequestPage(state: ListPaginationState, reset: boolean): number {
  return reset ? 0 : state.pageNo;
}

export function updateAfterFetch(
  state: ListPaginationState,
  totalRows: unknown,
  requestPage: number,
  fetchedCount: number
): void {
  state.totalRows = Number(totalRows ?? 0);
  state.pageNo = requestPage + 1;
  state.lastFetchedCount = Number(fetchedCount ?? 0);
}

export function appendUniqueById<T extends { id?: number | string | null }>(existing: T[], next: T[]): T[] {
  const existingIds = new Set(existing.map((row) => Number(row?.id)));
  const incoming = next.filter((row) => !existingIds.has(Number(row?.id)));
  return [...existing, ...incoming];
}
